import { base64UrlEncode } from './base64UrlEncode'

export async function pkceChallengeFromVerifier(verifier: string) {
  const encoder = new TextEncoder()
  const data = encoder.encode(verifier)
  const digest = await crypto.subtle.digest('SHA-256', data)
  return base64UrlEncode(digest)
}
